import { Statuses } from 'modules/processes/domain'

export const isMaterializedProcessCompleted = (status: string) => status == Statuses.Finalized
